import Moment from 'moment';

export default function normalizeDate(value) {

    if (value) {
        const newMoment = Moment(value);
        if (newMoment.isValid()) return newMoment.format("YYYY-MM-DD");
    }

    return null;

}